export const withBasePath = (path: string) => {
  const basePath = process.env.NEXT_PUBLIC_BASEPATH || '';
  return basePath + path;
};
